export default __webpack_public_path__ + "75ed9ea833384b4ac89d1ec75c4c8d2b.png";